import { render, staticRenderFns } from "./CategoryDeleteDialog.vue?vue&type=template&id=349a2660&"
import script from "./CategoryDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDeleteDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports